<!--The content below is only a placeholder and can be replaced.-->
<app-nav></app-nav>
<!-- <app-nav-chevron></app-nav-chevron> -->
<!-- <app-home></app-home> -->
<router-outlet></router-outlet>
<!-- <app-terminal></app-terminal> -->
<app-footer></app-footer>
